export default "__VITE_ASSET__6dhhlk7r__"